"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import AdvertisePopup from "./AdvertisePopup";
import { useAdSlot } from "./AdDataProvider";
import { useDevice } from '@/contexts/DeviceContext';
interface SectionBottomAdProps {
  slot: "section-bottom1" | "section-bottom2" | "article-bottom1" | "article-bottom";
  className?: string;
}

// Reserved dimensions by slot — matches common banner ad sizes (728x90 / 320x100 mobile)
// Reserving space before ad loads prevents CLS
const SLOT_DIMENSIONS: Record<string, {
  desktop: {
    w: number;
    h: number;
  };
  mobile: {
    w: number;
    h: number;
  };
}> = {
  "section-bottom1": {
    desktop: {
      w: 728,
      h: 90
    },
    mobile: {
      w: 320,
      h: 100
    }
  },
  "section-bottom2": {
    desktop: {
      w: 728,
      h: 90
    },
    mobile: {
      w: 320,
      h: 100
    }
  },
  "article-bottom1": {
    desktop: {
      w: 300,
      h: 250
    },
    mobile: {
      w: 300,
      h: 250
    }
  },
  "article-bottom": {
    desktop: {
      w: 728,
      h: 90
    },
    mobile: {
      w: 320,
      h: 100
    }
  }
};
export default function SectionBottomAd(t0) {
  const $ = _c(25);
  const {
    slot,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const adContentRef = useRef(null);
  const [adCode, setAdCode] = useState(null);
  const {
    isMobile,
    deviceDetected
  } = useDevice();
  const adSlotData = useAdSlot(slot);
  let t2;
  let t3;
  if ($[0] !== adSlotData || $[1] !== deviceDetected || $[2] !== isMobile) {
    t2 = () => {
      if (deviceDetected && adSlotData) {
        setAdCode(isMobile ? adSlotData.mobileAdCode || adSlotData.desktopAdCode : adSlotData.desktopAdCode);
      }
    };
    t3 = [adSlotData, isMobile, deviceDetected];
    $[0] = adSlotData;
    $[1] = deviceDetected;
    $[2] = isMobile;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== adCode || $[6] !== deviceDetected) {
    t4 = () => {
      if (!deviceDetected || !adCode || !adContentRef.current) {
        return;
      }
      let cleanedCode = adCode.trim();
      if (cleanedCode.startsWith("\"") && cleanedCode.endsWith("\"")) {
        cleanedCode = cleanedCode.slice(1, -1);
      }
      cleanedCode = cleanedCode.replace(/\\""/g, "\"").replace(/\\n/g, "\n").replace(/\\t/g, "\t").replace(/""/g, "\"");
      adContentRef.current.innerHTML = cleanedCode;
      const scripts = adContentRef.current.querySelectorAll("script");
      scripts.forEach(_temp);
    };
    $[5] = adCode;
    $[6] = deviceDetected;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== adCode) {
    t5 = [adCode];
    $[8] = adCode;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  useEffect(t4, t5);
  const dims = SLOT_DIMENSIONS[slot];
  const reservedW = isMobile ? dims.mobile.w : dims.desktop.w;
  const reservedH = isMobile ? dims.mobile.h : dims.desktop.h;
  const t6 = `flex justify-center ${className}`;
  const t7 = reservedW + 10;
  const t8 = reservedH + 10;
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = {
      width: t7,
      height: t8
    };
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== reservedH || $[14] !== reservedW) {
    t10 = <div ref={adContentRef} style={{
      width: reservedW,
      height: reservedH
    }} />;
    $[13] = reservedH;
    $[14] = reservedW;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== adCode) {
    t11 = adCode && <AdvertisePopup />;
    $[16] = adCode;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t11 || $[20] !== t9) {
    t12 = <div className="m-[5px]"><div className="bg-gray-100 p-[5px] relative" style={t9}>{t10}{t11}</div></div>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t6) {
    t13 = <div className={t6}>{t12}</div>;
    $[22] = t12;
    $[23] = t6;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
}
function _temp(script) {
  const newScript = document.createElement("script");
  Array.from(script.attributes).forEach(attr => {
    newScript.setAttribute(attr.name, attr.value);
  });
  if (script.src) {
    newScript.src = script.src;
  } else {
    newScript.textContent = script.textContent;
  }
  script.parentNode?.replaceChild(newScript, script);
}